import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import HealthCareReimbursementVzpSelect from './HealthCareReimbursementVzpSelect';

const HealthCareReimbursementVzpSelectField: React.FC<
	BaseFieldProps
> = props => (
	<BaseField {...props}>
		<HealthCareReimbursementVzpSelect />
	</BaseField>
);

export default HealthCareReimbursementVzpSelectField;
